import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/user.context';
import { AppThemeProvider } from './context/theme.context';
import { OperationalProviders } from './context/operational.context';
import { appCheckReady } from './config/firebase-config';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Ocultar el loader inicial del HTML
const hideInitialLoader = () => {
  const loader = document.getElementById('initial-loader');
  if (loader) {
    loader.style.display = 'none';
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));

const AppCheckError = () => (
  <main className="app-check-error">
    <h1>No pudimos verificar este navegador</h1>
    <p>
      Revisá tu conexión. Si estás trabajando localmente, registrá el token de
      depuración en Firebase App Check.
    </p>
    <button type="button" onClick={() => window.location.reload()}>
      Reintentar
    </button>
  </main>
);

const bootstrap = async () => {
  try {
    await appCheckReady;

    root.render(
      <React.StrictMode>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <AppThemeProvider>
            <AuthProvider>
              <OperationalProviders>
                <App />
              </OperationalProviders>
            </AuthProvider>
          </AppThemeProvider>
        </BrowserRouter>
      </React.StrictMode>
    );

    // This build has no worker. Retire only the previous worker for this app.
    serviceWorkerRegistration.retireLegacyServiceWorker();
  } catch (error) {
    console.error('Error validando App Check:', error);
    root.render(<AppCheckError />);
  } finally {
    hideInitialLoader();
  }
};

bootstrap();
